const DataTables = {
  calculateTableHeight: (visibleTableRows) => {
    const vuetify3Wrapper = document.querySelector('.v-table__wrapper')
    const headerHeight = document.querySelector(
      '.v-data-table-header, .v-table__wrapper > table > thead'
    )?.offsetHeight
    const rowHeight = vuetify3Wrapper
      ? 48
      : document.querySelector('.v-data-table__wrapper > table > tbody > tr')
          ?.offsetHeight
    return headerHeight + rowHeight * visibleTableRows || 'auto'
  }
}

export default DataTables
